import { css } from '@linaria/core';

export const tooltipContainerStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-space-gap-xs);
`;

export const hiddenNamesTriggerStyles = css`
  cursor: pointer;
  text-decoration: dotted underline;
`;
